export function parseContactImportApiErrors(responseBody: unknown): string[] {
  if (!responseBody || typeof responseBody !== 'object') {
    return ['An unexpected error occurred.'];
  }

  const body = responseBody as {
    errors?: unknown;
    message?: unknown;
  };

  if (Array.isArray(body.errors)) {
    return body.errors.map(String).filter(Boolean);
  }

  if (body.errors && typeof body.errors === 'object') {
    return Object.values(body.errors as Record<string, unknown>)
      .flatMap((value) => (Array.isArray(value) ? value : [value]))
      .map(String)
      .filter(Boolean);
  }

  if (typeof body.message === 'string' && body.message.trim()) {
    return [body.message.trim()];
  }

  return ['An unexpected error occurred.'];
}
